import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.75.75h237.5v237.5H.75z" }, null, -1),
    _createElementVNode("path", { d: "m.75 143.25 31.809 24.297A39.97 39.97 0 0 1 48.25 199.31v38.941m0-237.5v94.525a70.06 70.06 0 0 0 27.672 55.773L190.75 238.25m-95 0v-190h142.5m-95-47.5v237.5" }, null, -1)
  ])))
}
export default { render: render }